import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

import { queryClient } from "@/config/query-client";
import { type FileRouteTypes, routeTree } from "@/routeTree.gen";

export const router = createRouter({
  context: { queryClient },
  routeTree,
  scrollRestoration: true,
});

export type AvailableRoutesId = FileRouteTypes["id"];

export type AvailableRoutesToPath = FileRouteTypes["to"];

export type RootContext = { queryClient: QueryClient };

declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}
